(function () {
  if (window.__tdShippingCalloutInitialized) return;
  window.__tdShippingCalloutInitialized = true;

  const SHIPPING_EVENT = 'td-shipping-callout:update';

  function toCents(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getProductWrapper(el) {
    return el.closest('product-page') || document;
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getCalloutDisplay(config, wrapper) {
    const nextDisplay = config.nextElementSibling;
    if (nextDisplay && nextDisplay.matches('[data-shipping-callout-display]')) {
      return nextDisplay;
    }

    return wrapper.querySelector('[data-shipping-callout-display]');
  }

  function getActiveQuantityButton(wrapper) {
    const activeButtons = Array.from(wrapper.querySelectorAll('.td-quantity-button--active'));
    if (!activeButtons.length) return null;

    return (
      activeButtons.find((button) => button.closest('td-subscription-box') && isVisible(button)) ||
      activeButtons.find((button) => button.closest('td-bundle-quantity-selector') && isVisible(button)) ||
      activeButtons.find(isVisible) ||
      activeButtons[0]
    );
  }

  function isSubscriptionSelected(wrapper) {
    const sellingPlanInput = wrapper.querySelector('input[name="selling_plan"]');
    return !!(sellingPlanInput && sellingPlanInput.value);
  }

  function ensureBadge(button, config) {
    const existing = button.querySelector('.td-quantity-free-shipping-badge');
    if (existing) return existing;

    const badge = document.createElement('div');
    badge.className = 'td-quantity-free-shipping-badge';
    badge.setAttribute('role', 'status');
    badge.textContent = config.dataset.freeShippingBadgeText || 'Free Shipping';
    button.appendChild(badge);
    return badge;
  }

  function updateBadges(wrapper, config) {
    if (config.dataset.showFreeShippingBadge !== 'true') {
      wrapper.querySelectorAll('.td-quantity-free-shipping-badge').forEach(function (el) {
        el.remove();
      });
      return;
    }

    const threshold = toCents(config.dataset.freeShippingThreshold);
    const isSub = isSubscriptionSelected(wrapper);
    const configStyles = getComputedStyle(config);
    const badgeBg = configStyles.getPropertyValue('--fs-badge-bg');
    const badgeText = configStyles.getPropertyValue('--fs-badge-text');
    const badgeBorder = configStyles.getPropertyValue('--fs-badge-border');

    wrapper.querySelectorAll('.td-quantity-button').forEach(function (button) {
      const cents = isSub
        ? toCents(button.getAttribute('data-subscription-price-cents'))
        : toCents(button.getAttribute('data-one-time-price-cents'));
      const qualifies = threshold > 0 && cents >= threshold;
      let badge = button.querySelector('.td-quantity-free-shipping-badge');

      if (qualifies) {
        badge = ensureBadge(button, config);
        badge.style.setProperty('--fs-badge-bg', badgeBg);
        badge.style.setProperty('--fs-badge-text', badgeText);
        badge.style.setProperty('--fs-badge-border', badgeBorder);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function updateCallout(wrapper, config) {
    const callout = getCalloutDisplay(config, wrapper);
    if (!callout) return;

    const textEl = callout.querySelector('.td-shipping-callout__text');
    if (!textEl) return;

    if (config.dataset.dynamicEnabled !== 'true') return;

    const threshold = toCents(config.dataset.freeShippingThreshold);
    const activeButton = getActiveQuantityButton(wrapper);
    let qualifies = false;
    const defaultText =
      config.dataset.defaultText ||
      config.dataset.originalText ||
      textEl.dataset.originalText ||
      textEl.textContent;
    const qualifiedText = config.dataset.qualifiedText || defaultText;
    if (!textEl.dataset.originalText) {
      textEl.dataset.originalText = defaultText;
    }

    if (activeButton) {
      const isSub = isSubscriptionSelected(wrapper);
      const cents = isSub
        ? toCents(activeButton.getAttribute('data-subscription-price-cents'))
        : toCents(activeButton.getAttribute('data-one-time-price-cents'));
      qualifies = threshold > 0 && cents >= threshold;
    }

    callout.classList.toggle('td-shipping-callout--qualified', qualifies);
    textEl.textContent = qualifies
      ? qualifiedText
      : defaultText;
  }

  function updateForConfig(config) {
    const wrapper = getProductWrapper(config);
    updateBadges(wrapper, config);
    updateCallout(wrapper, config);
  }

  function updateAllShippingCallouts() {
    document.querySelectorAll('[data-shipping-callout-config]').forEach(updateForConfig);
  }

  function captureOriginalText() {
    document.querySelectorAll('[data-shipping-callout-config]').forEach(function (config) {
      const wrapper = getProductWrapper(config);
      const callout = getCalloutDisplay(config, wrapper);
      const textEl = callout?.querySelector('.td-shipping-callout__text');
      if (textEl && !textEl.dataset.originalText) {
        textEl.dataset.originalText = textEl.textContent;
      }
    });
  }

  document.addEventListener(SHIPPING_EVENT, function () {
    requestAnimationFrame(updateAllShippingCallouts);
  });

  document.addEventListener('DOMContentLoaded', function () {
    captureOriginalText();
    document.dispatchEvent(new CustomEvent(SHIPPING_EVENT));
  });

  document.addEventListener('shopify:section:load', function () {
    captureOriginalText();
    document.dispatchEvent(new CustomEvent(SHIPPING_EVENT));
  });

  document.addEventListener('section-content::changed', function () {
    captureOriginalText();
    document.dispatchEvent(new CustomEvent(SHIPPING_EVENT));
  });
})();
